import { useMemo, useRef, useState } from 'react';
const REMOVE_OUTLINE_IF_NOT_OVER_DELAY = 60;
const SET_OPENED_ON_OVER_DELAY = 1800;
export function useOpenParentContainerOnDragOver({ setOpened }) {
    const pageOverTimer = useRef(null);
    const openTimer = useRef(null);
    const [isOver, setIsOver] = useState(false);
    const parentContainerProps = useMemo(() => ({
        onDragOverCapture: (event) => {
            const isOverParentContainer = event.currentTarget.contains(event.target);
            if (isOverParentContainer) {
                pageOverTimer.current && clearTimeout(pageOverTimer.current);
                setIsOver(true);
                // Set isOver false if another dragover event is not fired within 60 ms
                // Usually it is fired every 1 to 50 ms (https://developer.mozilla.org/en-US/docs/Web/API/DragEvent)
                pageOverTimer.current = setTimeout(() => {
                    setIsOver(false);
                    pageOverTimer.current = null;
                }, REMOVE_OUTLINE_IF_NOT_OVER_DELAY);
                // Call method to open card if dragover event is being fired for at least 1800 ms
                openTimer.current = setTimeout(() => {
                    if (pageOverTimer.current) {
                        setOpened(true);
                        openTimer.current = null;
                    }
                }, SET_OPENED_ON_OVER_DELAY);
            }
        }
    }), [setOpened]);
    return {
        parentContainerProps,
        isOver
    };
}
